import { useIsAdminPath } from '~/composables/use-is-admin-path';
import { useAuth } from '~/modules/auth/composables/use-auth';

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const { isAdminPath } = useIsAdminPath();
  const { setUser } = useAuth();

  if (isAdminPath(_from.path)) {
    try {
      await setUser();
    } catch (e) {
      // suspend
    }
  }
});
